import React, { useEffect } from "react";
import { ReactComponent as ClientIcon } from "../../../assets/icons/modal/client.svg";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddClientForm from "../forms/AddClientForm/AddClientForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddClientsModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати клієнта"
          subTitle='Додайте нового клієнта до системи. Заповніть необхідну інформацію та натисніть "Додати клієнта".'
        >
          <ClientIcon />
        </ModalTitle>
        <AddClientForm onApply={onApply} onClose={props.onClose} />
      </div>
    </DefaultModal>
  );
};

export default AddClientsModal;
